import PropTypes from 'prop-types';
import {TripPropTypes} from "./TripPropTypes";

export const GuestInfoPropTypes = PropTypes.shape({
    guestId: PropTypes.number,
    sex: PropTypes.string,
    beds: PropTypes.number,
    consent: PropTypes.number,
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    cellphone: PropTypes.string,
    birthdate: PropTypes.string,
});

const BedRoomInfoPropTypes = PropTypes.shape({
    roomInfoId: PropTypes.number,
    roomClassFk: PropTypes.number,
    tripTypeFk: PropTypes.number,
    shipFk: PropTypes.number,
    enabled: PropTypes.number,
    locationFk: PropTypes.number,
    seasonFk: PropTypes.number,
    heading: PropTypes.string,
    roomDescription: PropTypes.string,
    roomImages: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
});

export const AccommodationPropTypes = PropTypes.shape({
    bedId: PropTypes.number,
    bookFk: PropTypes.number,
    tripFk: PropTypes.number,
    guestFk: PropTypes.number,
    roomNameFk: PropTypes.number,
    roomClassFk: PropTypes.number,
    isSingle: PropTypes.number,
    bed: PropTypes.number,
    price: PropTypes.string,
    singlesurcharge: PropTypes.number,
    roomTitle: PropTypes.string,
    guest: GuestInfoPropTypes,
    room_info: BedRoomInfoPropTypes,
});


export const GuestsPropTypes = PropTypes.arrayOf(PropTypes.shape({
    guestFk: PropTypes.number,
    tripFk: PropTypes.number,
    bookFk: PropTypes.number,
    diveCertAgency: PropTypes.string,
    diveCertNumber: PropTypes.string,
    diverType: PropTypes.string,
    travelIns: PropTypes.string,
    nitroxCertAgency: PropTypes.string,
    nitroxCertNum: PropTypes.string,
    healthInsProvider: PropTypes.string,
    healthInsStart: PropTypes.string,
    healthInsNum: PropTypes.string,
    diveInsProvider: PropTypes.string,
    diveInsNum: PropTypes.string,
    diveInsExpiryDate: PropTypes.string,
    insuranceProvider: PropTypes.string,
    insuranceNum: PropTypes.string,
    menu: PropTypes.string,
    waiver: PropTypes.number,
    covidwaiver: PropTypes.number,
    checkedIn: PropTypes.number,
    risks: PropTypes.number,
    waiverSigned: PropTypes.number,
    covidwaiverSigned: PropTypes.number,
    risksSigned: PropTypes.number,
    waiverSynced: PropTypes.number,
    medicalYesNo: PropTypes.number,
    allergyYesNo: PropTypes.number,
    injuryYesNo: PropTypes.number,
    medical: PropTypes.string,
    allergies: PropTypes.string,
    injury: PropTypes.string,
    comment: PropTypes.string,
    rentRequest: PropTypes.string,
    passportNum: PropTypes.string,
    passportPlaceOfBirth: PropTypes.string,
    passportPlaceOfIssue: PropTypes.string,
    passportExpiryDate: PropTypes.string,
    passportDateOfIssue: PropTypes.string,
    citizenIso: PropTypes.string,
    height: PropTypes.string,
    weight: PropTypes.string,
    shoesize: PropTypes.string,
    guestHash: PropTypes.string,
    address: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postcode: PropTypes.string,
    countryIso: PropTypes.string,
    passportCountryIso: PropTypes.string,
    emergContact: PropTypes.string,
    emergPhone: PropTypes.string,
    emergRelation: PropTypes.string,
    meetIn: PropTypes.string,
    ensHospitality: PropTypes.number,
    flightInDate: PropTypes.string,
    flightInTime: PropTypes.string,
    flightInAirline: PropTypes.string,
    flightInHotel: PropTypes.string,
    flightOutDate: PropTypes.string,
    flightOutTime: PropTypes.string,
    flightOutAirline: PropTypes.string,
    flightOutHotel: PropTypes.string,
    diverDives: PropTypes.string,
    diverYears: PropTypes.string,
    diverFitness: PropTypes.string,
    guestInfo: GuestInfoPropTypes,
    percentage: PropTypes.number,
    roomTitle: PropTypes.string,
    isSingle: PropTypes.bool,
    trip: TripPropTypes,
    accommodation: AccommodationPropTypes
}));